import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import alphalogo from '../../../utils/alphahorizontal.png';

const createStyles = (primaryColor = '#005695', secondaryColor = '#0067b2') => {
  // Color palette
  const colors = {
    primary: primaryColor,
    secondary: secondaryColor,
    gray: {
      50: '#F9FAFB',
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      800: '#1F2937',
    },
    white: '#FFFFFF'
  };

  return StyleSheet.create({
    // Content Layout
    content: {
      flexDirection: 'row',
      gap: 10,
    },
    leftColumn: {
      width: '40%',  // Aumentado de 35% a 40%
    },
    rightColumn: {
      width: '60%',  // Ajustado de 65% a 60%
    },
    
    // Prestador Logo
    prestadorLogoContainer: {
      alignItems: 'center',
      marginBottom: 10,
    },
    prestadorLogo: {
      width: 110,
      height: 90,
      borderRadius: 6,
      objectFit: 'contain',
      borderWidth: 1,
      borderColor: colors.gray[200],
      backgroundColor: colors.gray[50],
      padding: 4,
    },
    
    // Section Styles
    section: {
      backgroundColor: colors.white,
      padding: 5,
      borderRadius: 8,
      marginBottom: 8,
      borderWidth: 1,
      borderColor: colors.gray[200],
    },
    sectionTitle: {
      backgroundColor: colors.primary,
      padding: '8 12',
      borderRadius: 4,
      marginBottom: 5,
    },
    sectionTitleText: {
      fontSize: 10,
      color: colors.white,
      fontWeight: 'bold',
    },
    
    // Equipment Section Styles
    equipmentContent: {
      flexDirection: 'row',
      gap: 10,
    },
    equipmentImageContainer: {
      width: '35%',
    },
    equipmentImage: {
      width: '100%',
      height: 120,
      borderRadius: 6,
      objectFit: 'contain',
      borderWidth: 1,
      borderColor: colors.gray[200],
      backgroundColor: colors.gray[50],
      padding: 4,
    },
    equipmentInfo: {
      flex: 1,
      gap: 2,
    },
    
    // Data Display
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 6,
      gap: 10,
    },
    label: {
      fontSize: 8,
      color: colors.gray[800],
      fontWeight: 'bold',
      width: '35%',
    },
    
    // Images
    image: {
      width: 100,
      height: 100,
      borderRadius: 6,
      marginBottom: 12,
      objectFit: 'cover',
      borderWidth: 1,
      borderColor: colors.gray[200],
    },
    // Base page setup
    page: {
      backgroundColor: colors.white,
      padding: 20,
      paddingBottom: 40,
      fontFamily: 'Helvetica',
    },

    // Header styles
    header: {
      backgroundColor: colors.white,
      padding: 10,
      borderRadius: 8,
      marginBottom: 10,
      borderWidth: 1,
      borderColor: colors.gray[200],
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    },
    headerContent: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 20,
    },
    headerLogoContainer: {
      backgroundColor: colors.white,
      padding: 8,
      borderRadius: 6,
      borderWidth: 1,
      borderColor: colors.gray[200],
      width: '30%',
    },
    headerLogo: {
      width: '100%',
      height: 40,
      objectFit: 'contain',
    },
    headerTitle: {
      backgroundColor: colors.primary,
      padding: '8 12',
      borderRadius: 6,
      width: '40%',
    },
    headerTitleText: {
      fontSize: 11,
      color: colors.white,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    headerInfo: {
      width: '25%',
      gap: 6,
    },
    headerInfoItem: {
      backgroundColor: colors.gray[50],
      padding: '6 10',
      borderRadius: 4,
      marginBottom: 4,
    },
// Maintenance Checks
checkGrid: {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 6,
},

checkLabel: {
  fontSize: 8,
  color: colors.gray[800],
  fontWeight: 'bold',
  flex: 1,
},
checkValue: {
  fontSize: 8,
  fontWeight: 'bold',
  marginLeft: 8,
},
checkGrid: {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 8,
},
checkItem: {
  width: '48%',
  backgroundColor: colors.gray[50],
  padding: '6 8',
  borderRadius: 4,
  marginBottom: 2,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderWidth: 1,
  borderColor: colors.gray[200],
},
checkLabel: {
  fontSize: 8,
  color: colors.gray[800],
  fontWeight: 'bold',
  flex: 1,
},
checkValue: {
  fontSize: 8,
  fontWeight: 'bold',
  marginLeft: 8,
},
checkValueTrue: {
  fontSize: 8,
  fontWeight: 'bold',
  marginLeft: 8,
  color: colors.primary,
},
checkValueFalse: {
  fontSize: 8,
  fontWeight: 'bold',
  marginLeft: 8,
  color: colors.gray[800],
},
    // Footer styles
    footer: {
      position: 'absolute',
      bottom: 10,
      left: 30,
      right: 30,
      borderTopWidth: 1,
      borderColor: colors.gray[200],
      paddingTop: 2,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    footerLogo: {
      width: 120,
      height: 24,
      objectFit: 'contain',
    },
    footerText: {
      fontSize: 8,
      color: colors.gray[800],
    },
    footerWeb: {
      fontSize: 9,
      color: colors.primary,
      fontWeight: 'bold',
    },

    observationsContainer: {
      gap: 4,
    },
    observationsLabel: {
      fontSize: 8,
      color: colors.gray[800],
      fontWeight: 'bold',
    },
    observationsBox: {
      backgroundColor: colors.gray[50],
      padding: 8,
      borderRadius: 4,
      borderWidth: 1,
      borderColor: colors.gray[200],
      minHeight: 95,
    },
    observationsBox2: {
      backgroundColor: colors.gray[50],
      padding: 8,
      borderRadius: 4,
      borderWidth: 1,
      borderColor: colors.gray[200],
      minHeight: 108,
    },
    observationsText: {
      fontSize: 9,
      color: colors.gray[800],
      lineHeight: 1.4,
    },
    timeRow: {
      flexDirection: 'column',
      gap: 6,
      marginBottom: 10,
    },
    timeItem: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: colors.gray[50],
      padding: '6 8',
      borderRadius: 4,
      borderWidth: 1,
      borderColor: colors.gray[200],
    },

    // Common text styles
    text: {
      fontSize: 8,
      color: colors.gray[800],
    },
    value: {
      fontSize: 8,
      color: colors.gray[800],
      flex: 1,
    },
      // Personnel Section Styles
      personnelSection: {
        marginTop: 2,
        height: 85,
      },
      personnelContainer: {
        flexDirection: 'row',
        gap: 2,
        backgroundColor: colors.white,
        padding: 2,
        border:'none',
        height: '100%',
      },
      personnelHalf: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: colors.white,
        padding: 1,
        borderRadius: 4,
        borderWidth: 1,
        borderColor: colors.gray[200],
        gap: 2,
      },
      signatureContainer: {
        width: '40%',
        height: '70%',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.gray[50],
        borderRadius: 4,
        borderWidth: 1,
        borderColor: colors.gray[200],
      },
      signatureImage: {
        width: '90%',
        height: '90%',
        objectFit: 'contain',
      },
      noSignatureText: {
        fontSize: 8,
        color: colors.gray[800],
        fontStyle: 'italic',
      },
      personnelInfo: {
        flex: 1,
        gap: 2,
      },
      infoItem: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 4,
      },
      labelPersonnel: {
        fontSize: 10,
        color: colors.gray[800],
        fontWeight: 'bold',
        marginBottom: 4,
      },
      roleText: {
        fontSize: 9,
        color: colors.primary,
      },

    pruebasGrid: {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: 6,
},

pruebaFila: {
  width: '48%',
  backgroundColor: colors.gray[50],
  padding: 6,
  borderRadius: 4,
  borderWidth: 1,
  borderColor: colors.gray[200],
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
},

pruebaFilaInterna: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: 4,
},

pruebaCampo2col: {
  width: '48%',
},

pruebaLabel: {
  fontSize: 9,
  fontWeight: 'bold',
  color: colors.gray[800],
},

pruebaValor: {
  fontSize: 9,
  color: colors.gray[800],
},

repuestosGrid: {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: 2,
  marginTop: 1,
},

repuestoItem: {
  width: '31%', // 3 elementos por fila (con espacio entre ellos)
  backgroundColor: colors.gray[50],
  padding: 2,
  borderRadius: 4,
  borderWidth: 1,
  borderColor: colors.gray[200],
  minHeight: 20,
  justifyContent: 'center',
},

repuestoItemText: {
  fontSize: 9,
  color: colors.gray[800],
  fontWeight: 'bold',
  textAlign: 'center',
},
registroFotosGrid: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: 4,
  marginTop: 4,
},

registroFotoItem: {
  width: '32%',
  aspectRatio: 1,
  borderWidth: 1,
  borderColor: colors.gray[200],
  borderRadius: 4,
  backgroundColor: colors.gray[50],
  alignItems: 'center',
  justifyContent: 'center',
  padding: 2,
},

registroFotoImagen: {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 2,
},

registroFotoTexto: {
  fontSize: 7,
  color: colors.gray[300],
  fontStyle: 'italic',
  textAlign: 'center',
  padding: 2,
},
ejecucionGrid: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: 5,
},

ejecucionColumna: {
  width: '48%',
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
},

ejecucionItem: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: colors.gray[50],
  borderRadius: 4,
  borderWidth: 1,
  borderColor: colors.gray[200],
  padding: '2 3',
  marginTop:2, 
  marginBottom:2
},

ejecucionTexto: {
  fontSize: 9,
  marginTop:3, 
  marginBottom:3,
  fontWeight: 'bold',
  color: colors.gray[800],
},
  });
};

const ReporteMtoDocuPDFV2 = ({ equipo, cliente, mtopreventivo }) => {
  if (!equipo || !cliente || !mtopreventivo) {
    return (
      <Document>
        <Page size="A4">
          <View>
            <Text>No hay información disponible</Text>
          </View>
        </Page>
      </Document>
    );
  }

  const styles = createStyles(cliente.primaryColor, cliente.secondaryColor);
  const imagenUrl = cliente.imagenurl || 'https://firebasestorage.googleapis.com/v0/b/alphaplatform.appspot.com/o/noImg.png?alt=media';
  const imagenEquipoUrl = equipo.credentials.imagenurl || 'https://firebasestorage.googleapis.com/v0/b/alphaplatform.appspot.com/o/noImg.png?alt=media';

  const Footer = () => (
    <View style={styles.footer} fixed>
      <View>
        <Image src={alphalogo} style={styles.footerLogo} />
      </View>
      <View>
        <Text style={styles.footerWeb}>www.alphabiomedica.com</Text>
      </View>
    </View>
  );

  const tienePruebas = (mtopreventivo.pruebas || []).length > 0;
    const tieneRepuestos = (mtopreventivo.repuestos || []).length > 0;
    const tieneImagenes = [
      mtopreventivo.imagenAdjunta1,
      mtopreventivo.imagenAdjunta2,
      mtopreventivo.imagenAdjunta3,
    ].some(Boolean);

    const mostrarSegundaPagina = tienePruebas || tieneRepuestos || tieneImagenes;

  return (
    
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerContent}>
            <View style={styles.headerLogoContainer}>
              <Image
                src={
                  cliente.plantillaType === 'empresa'
                    ? cliente.logoUrl
                    : cliente.imagenurl
                }
                style={styles.headerLogo}
              />
            </View>
            <View style={styles.headerTitle}>
              <Text style={styles.headerTitleText}>REPORTE DE MANTENIMIENTO PREVENTIVO</Text>
            </View>
            <View style={styles.headerInfo}>
              <View style={styles.headerInfoItem}>
            <Text style={styles.value}>
              Reporte No: {(mtopreventivo.mtoprevid || '').toString().slice(-6) || 'N/A'}
            </Text>
          </View>
              <View style={styles.headerInfoItem}>
                <Text style={styles.value}>Fecha: {mtopreventivo.fecha || 'N/A'}</Text>
              </View>

               <View style={styles.headerInfoItem}>
              <Text style={styles.value}>
                Página: {`1 de ${mostrarSegundaPagina ? '2' : '1'}`}
              </Text>
            </View>
            </View>
          </View>
        </View>

        {/* Main Content */}
        <View style={styles.content}>
          {/* Left Column - Client Information */}
          <View style={styles.leftColumn}>
            <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text style={styles.sectionTitleText}>INFORMACIÓN DEL PRESTADOR</Text>
              </View>
            
              <View style={styles.row}>
                <Text style={styles.label}>NOMBRE:</Text>
                <Text style={styles.value}>{cliente.nombre}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>CC/NIT:</Text>
                <Text style={styles.value}>{cliente.ccnit}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>CIUDAD:</Text>
                <Text style={styles.value}>{cliente.ciudad}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>DIRECCIÓN:</Text>
                <Text style={styles.value}>{cliente.direccion}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>TELÉFONO:</Text>
                <Text style={styles.value}>{cliente.telefono}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>EMAIL:</Text>
                <Text style={styles.value}>{cliente.email}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>SEDE:</Text>
                <Text style={styles.value}>{cliente.sede}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>CÓDIGO REPS:</Text>
                <Text style={styles.value}>{cliente.codigoreps}</Text>
              </View>
            </View>

            

                  <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text style={styles.sectionTitleText}>ACTIVIDADES</Text>
              </View>
              <View style={styles.executionDetails}>
                
                <View style={styles.observationsContainer}>
                  <Text style={styles.observationsLabel}>ACTIVIDADES PROGRAMADAS:</Text>
                  <View style={styles.observationsBox}>
                    <Text style={styles.observationsText}>
                      {mtopreventivo.actividadesprog || 'Sin información para mostrar'}
                    </Text>
                  </View>
                </View>
                 <View style={styles.observationsContainer}>
                  <Text style={styles.observationsLabel}>ACTIVIDADES REALIZADAS:</Text>
                  <View style={styles.observationsBox}>
                    <Text style={styles.observationsText}>
                      {mtopreventivo.actividadesreal || 'Sin información para mostrar'}
                    </Text>
                  </View>
                </View>

                <View style={styles.observationsContainer}>
                  <Text style={styles.observationsLabel}>OBSERVACIONES:</Text>
                  <View style={styles.observationsBox}>
                    <Text style={styles.observationsText}>
                      {mtopreventivo.observaciones || 'Sin información para mostrar'}
                    </Text>
                  </View>
                </View>
                </View>
                </View>
          </View>

          {/* Right Column - Equipment Information */}
          <View style={styles.rightColumn}>
            <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text style={styles.sectionTitleText}>INFORMACIÓN DEL EQUIPO</Text>
              </View>
              <View style={styles.equipmentContent}>
                <View style={styles.equipmentImageContainer}>
                  <Image src={imagenEquipoUrl} style={styles.equipmentImage} />
                </View>
                <View style={styles.equipmentInfo}>
                  <View style={styles.row}>
                    <Text style={styles.label}>NOMBRE:</Text>
                    <Text style={styles.value}>{equipo.credentials.nombre}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.label}>ID INVENTARIO:</Text>
                    <Text style={styles.value}>{equipo.credentials.idinventario}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.label}>MARCA:</Text>
                    <Text style={styles.value}>{equipo.credentials.marca}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.label}>MODELO:</Text>
                    <Text style={styles.value}>{equipo.credentials.modelo}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.label}>SERIE:</Text>
                    <Text style={styles.value}>{equipo.credentials.serie}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.label}>UBICACIÓN:</Text>
                    <Text style={styles.value}>{equipo.credentials.ubicacion}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.label}>SERVICIO:</Text>
                    <Text style={styles.value}>{equipo.credentials.servicio}</Text>
                  </View>
                </View>
              </View>
            </View>

              {/* Maintenance Checks */}
              <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text style={styles.sectionTitleText}>ACTIVIDADES DE MANTENIMIENTO</Text>
              </View>
              <View style={styles.checkGrid}>
                {[
                  { label: 'INSPECCIÓN CHASIS', value: mtopreventivo.chasis },
                  { label: 'VERIFICACIÓN DE ACCESORIOS', value: mtopreventivo.vaccesorios },
                  { label: 'PRUEBA CUANTITATIVA', value: mtopreventivo.pcuantitativa },
                  { label: 'VERIFICACIÓN DE CONTROLES', value: mtopreventivo.vcontroles },
                  { label: 'PRUEBAS ELECTRICAS', value: mtopreventivo.selectrica },
                  { label: 'LIMPIEZA', value: mtopreventivo.limpieza },
                  { label: 'LIMPIEZA CHASIS', value: mtopreventivo.lchasis },
                  { label: 'LUBRICACIÓN DE PARTES', value: mtopreventivo.lubricacion },
                  { label: 'LIMPIEZA ELECTRÓNICA', value: mtopreventivo.lelectronica },
                  { label: 'VERIFICACIÓN GENERAL', value: mtopreventivo.vgeneral }
                ].map((item, index) => (
                  <View key={index} style={styles.checkItem}>
                    <Text style={styles.checkLabel}>{item.label}</Text>
                    <Text style={item.value ? styles.checkValueTrue : styles.checkValueFalse}>
                      {item.value ? 'Si' : 'N/A'}
                    </Text>
                  </View>
                ))}
              </View>
            </View>

            {/* Technical Tests */}
           {/* Execution Times and Observations */}
             <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text style={styles.sectionTitleText}>DETALLES DE EJECUCIÓN</Text>
              </View>
            <View style={styles.ejecucionGrid}>
  {/* Columna izquierda: Fechas y horas */}
  <View style={styles.ejecucionColumna}>
    <View style={styles.ejecucionItem}>
      <Text style={styles.ejecucionTexto}>Fecha inicio:</Text>
      <Text style={styles.ejecucionTexto}>{mtopreventivo.fecha || 'N/A'}</Text>
    </View>
    <View style={styles.ejecucionItem}>
      <Text style={styles.ejecucionTexto}>Hora inicio:</Text>
      <Text style={styles.ejecucionTexto}>{mtopreventivo.horainicio || 'N/A'}</Text>
    </View>
    <View style={styles.ejecucionItem}>
      <Text style={styles.ejecucionTexto}>Fecha final:</Text>
      <Text style={styles.ejecucionTexto}>{mtopreventivo.fechafinal || 'N/A'}</Text>
    </View>
    <View style={styles.ejecucionItem}>
      <Text style={styles.ejecucionTexto}>Hora final:</Text>
      <Text style={styles.ejecucionTexto}>{mtopreventivo.horafinal || 'N/A'}</Text>
    </View>
  </View>

  {/* Columna derecha: Estado del equipo */}
  <View style={styles.ejecucionColumna}>
    <View style={styles.ejecucionItem}>
      <Text style={styles.ejecucionTexto}>¿Apto para uso?</Text>
      <Text style={styles.ejecucionTexto}>{mtopreventivo.aptouso ? 'Sí' : 'No'}</Text>
    </View>
    <View style={styles.ejecucionItem}>
      <Text style={styles.ejecucionTexto}>¿Requiere repuestos?</Text>
      <Text style={styles.ejecucionTexto}>{mtopreventivo.repuestosreq ? 'Sí' : 'No'}</Text>
    </View>
    <View style={styles.ejecucionItem}>
      <Text style={styles.ejecucionTexto}>¿Requiere correctivo?</Text>
      <Text style={styles.ejecucionTexto}>{mtopreventivo.reqmtocorr ? 'Sí' : 'No'}</Text>
    </View>
    <View style={styles.ejecucionItem}>
      <Text style={styles.ejecucionTexto}>¿Dar de baja?</Text>
      <Text style={styles.ejecucionTexto}>{mtopreventivo.bajaequipo ? 'Sí' : 'No'}</Text>
    </View>
  </View>
</View>
                </View>
              
            </View>
        </View>
         {/* Personnel Information */}
         {/* Personnel Information */}
<View style={styles.personnelSection}>
  <View style={styles.sectionTitle}>
    <Text style={styles.sectionTitleText}>INFORMACIÓN DEL PERSONAL</Text>
  </View>
  <View style={styles.personnelContainer}>
    {/* Recipient - Varía según el método de recepción */}
    <View style={styles.personnelHalf}>
      <View style={styles.signatureContainer}>
        {/* Para método 'manual' */}
        {(mtopreventivo.metodoRecepcion === 'manual' || !mtopreventivo.metodoRecepcion) && (
          cliente.imagenfirma ? (
            <Image src={cliente.imagenfirma} style={styles.signatureImage} />
          ) : (
            <Text style={styles.noSignatureText}>Pendiente firma</Text>
          )
        )}
        
        {/* Para método 'firma' o 'imagen' */}
        {(mtopreventivo.metodoRecepcion === 'firma' || mtopreventivo.metodoRecepcion === 'imagen') && (
          mtopreventivo.imagenfirma ? (
            <Image src={mtopreventivo.imagenfirma} style={styles.signatureImage} />
          ) : (
            <Text style={styles.noSignatureText}>Pendiente firma</Text>
          )
        )}
        
        {/* Para método 'usuario' */}
        {mtopreventivo.metodoRecepcion === 'usuario' && (
          mtopreventivo.imagenfirma ? (
            <Image src={mtopreventivo.imagenfirma} style={styles.signatureImage} />
          ) : (
            <Text style={styles.noSignatureText}>Pendiente firma</Text>
          )
        )}
      </View>
      <View style={styles.personnelInfo}>
        <View style={styles.infoItem}>
          <Text style={styles.labelPersonnel}>{mtopreventivo.firmarecibe || 'N/A'}</Text>
          <Text style={styles.roleText}>{mtopreventivo.cargorecibe || 'Receptor'}</Text>
        </View>
      </View>
    </View>

    {/* Engineer */}
    <View style={styles.personnelHalf}>
      <View style={styles.signatureContainer}>
        {mtopreventivo.firmaIngeniero ? (
          <Image src={mtopreventivo.firmaIngeniero} style={styles.signatureImage} />
        ) : (
          <Text style={styles.noSignatureText}>Pendiente firma</Text>
        )}
      </View>
      <View style={styles.personnelInfo}>
        <View style={styles.infoItem}>
        <Text style={styles.labelPersonnel}>
          {mtopreventivo.handle || mtopreventivo.handleuser || 'N/A'}
        </Text>
          <Text style={styles.roleText}>Ingeniero Biomédico</Text>
        </View>
      </View>
    </View>
  </View>
</View>


        {/* Footer */}
        <Footer />
      </Page>
 {mostrarSegundaPagina && ( <Page size="A4" style={styles.page}>

          {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerContent}>
            <View style={styles.headerLogoContainer}>
                  <Image
                src={
                  cliente.plantillaType === 'empresa'
                    ? cliente.logoUrl
                    : cliente.imagenurl
                }
                style={styles.headerLogo}
              />
            </View>
            <View style={styles.headerTitle}>
              <Text style={styles.headerTitleText}>REPORTE DE MANTENIMIENTO PREVENTIVO</Text>
            </View>
            <View style={styles.headerInfo}>
             <View style={styles.headerInfoItem}>
                <Text style={styles.value}>
                  Reporte No: {(mtopreventivo.mtoprevid || '').toString().slice(-6) || 'N/A'}
                </Text>
              </View>
              <View style={styles.headerInfoItem}>
                <Text style={styles.value}>Fecha: {mtopreventivo.fecha || 'N/A'}</Text>
              </View>
              <View style={styles.headerInfoItem}>
                <Text style={styles.value}>Pagina: {'2 de 2'}</Text>
              </View>
            </View>
          </View>
        </View>

<View style={styles.section}>
  <View style={styles.sectionTitle}>
    <Text style={styles.sectionTitleText}>MEDICIONES REALIZADAS</Text>
  </View>

  <View style={styles.observationsContainer}>
    {(mtopreventivo.pruebas || []).length > 0 ? (
      <View style={styles.pruebasGrid}>
        {mtopreventivo.pruebas.slice(0, 6).map((p, index) => (
          <View key={index} style={styles.pruebaFila}>
            {/* Fila 1 */}
            <View style={styles.pruebaFilaInterna}>
              <View style={styles.pruebaCampo2col}>
                <Text style={styles.pruebaLabel}>Instrumento</Text>
                <Text style={styles.pruebaValor}>{p.instrumento || 'N/A'}</Text>
              </View>
              <View style={styles.pruebaCampo2col}>
                <Text style={styles.pruebaLabel}>Variable</Text>
                <Text style={styles.pruebaValor}>{p.prueba || 'N/A'}</Text>
              </View>
            </View>

            {/* Fila 2 */}
            <View style={styles.pruebaFilaInterna}>
              <View style={styles.pruebaCampo2col}>
                <Text style={styles.pruebaLabel}>Valor</Text>
                <Text style={styles.pruebaValor}>{p.valor || 'N/A'}</Text>
              </View>
              <View style={styles.pruebaCampo2col}>
                <Text style={styles.pruebaLabel}>Valor Medido</Text>
                <Text style={styles.pruebaValor}>{p.valormed || 'N/A'}</Text>
              </View>
            </View>
          </View>
        ))}
      </View>
    ) : (
      <Text style={styles.text}>
        No hay mediciones para mostrar.
      </Text>
    )}
  </View>
</View>

              <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text style={styles.sectionTitleText}>REPUESTOS UTILIZADOS</Text>
              </View>

              {(mtopreventivo.repuestos || []).length > 0 ? (
                <View style={styles.repuestosGrid}>
                  {mtopreventivo.repuestos.slice(0, 6).map((nombre, index) => (
                    <View key={index} style={styles.repuestoItem}>
                      <Text style={styles.repuestoItemText}>{nombre || 'N/A'}</Text>
                    </View>
                  ))}
                </View>
              ) : (
                <Text style={styles.text}>No hay repuestos para mostrar</Text>
              )}
            </View>

            <View style={styles.section}>
  <View style={styles.sectionTitle}>
    <Text style={styles.sectionTitleText}>REGISTRO FOTOGRÁFICO</Text>
  </View>

  {(() => {
    const imagenes = [
      mtopreventivo.imagenAdjunta1,
      mtopreventivo.imagenAdjunta2,
      mtopreventivo.imagenAdjunta3
    ];

    const cantidadImagenes = imagenes.filter(Boolean).length;

    if (cantidadImagenes === 0) {
      return (
        <Text style={styles.text}>
          No hay imagenes para mostrar.
        </Text>
      );
    }

    return (
      <View style={styles.registroFotosGrid}>
        {imagenes.map((url, idx) => (
          <View key={`img-${idx}`} style={styles.registroFotoItem}>
            {url ? (
              <Image src={url} style={styles.registroFotoImagen} />
            ) : (
              <Text style={styles.registroFotoTexto}>Sin imagen</Text>
            )}
          </View>
        ))}
      </View>
    );
  })()}
</View>



        {/* Personnel Information */}
<View style={styles.personnelSection}>
  <View style={styles.sectionTitle}>
    <Text style={styles.sectionTitleText}>INFORMACIÓN DEL PERSONAL</Text>
  </View>
  <View style={styles.personnelContainer}>
    {/* Recipient - Varía según el método de recepción */}
    <View style={styles.personnelHalf}>
      <View style={styles.signatureContainer}>
        {/* Para método 'manual' */}
        {(mtopreventivo.metodoRecepcion === 'manual' || !mtopreventivo.metodoRecepcion) && (
          cliente.imagenfirma ? (
            <Image src={cliente.imagenfirma} style={styles.signatureImage} />
          ) : (
            <Text style={styles.noSignatureText}>Pendiente firma</Text>
          )
        )}
        
        {/* Para método 'firma' o 'imagen' */}
        {(mtopreventivo.metodoRecepcion === 'firma' || mtopreventivo.metodoRecepcion === 'imagen') && (
          mtopreventivo.imagenfirma ? (
            <Image src={mtopreventivo.imagenfirma} style={styles.signatureImage} />
          ) : (
            <Text style={styles.noSignatureText}>Pendiente firma</Text>
          )
        )}
        
        {/* Para método 'usuario' */}
        {mtopreventivo.metodoRecepcion === 'usuario' && (
          mtopreventivo.imagenfirma ? (
            <Image src={mtopreventivo.imagenfirma} style={styles.signatureImage} />
          ) : (
            <Text style={styles.noSignatureText}>Pendiente firma</Text>
          )
        )}
      </View>
      <View style={styles.personnelInfo}>
        <View style={styles.infoItem}>
          <Text style={styles.labelPersonnel}>{mtopreventivo.firmarecibe || 'N/A'}</Text>
          <Text style={styles.roleText}>{mtopreventivo.cargorecibe || 'Receptor'}</Text>
        </View>
      </View>
    </View>

    {/* Engineer */}
    <View style={styles.personnelHalf}>
      <View style={styles.signatureContainer}>
        {mtopreventivo.firmaIngeniero ? (
          <Image src={mtopreventivo.firmaIngeniero} style={styles.signatureImage} />
        ) : (
          <Text style={styles.noSignatureText}>Pendiente firma</Text>
        )}
      </View>
      <View style={styles.personnelInfo}>
        <View style={styles.infoItem}>
        <Text style={styles.labelPersonnel}>
          {mtopreventivo.handle || mtopreventivo.handleuser || 'N/A'}
        </Text>
          <Text style={styles.roleText}>Ingeniero Biomédico</Text>
        </View>
      </View>
    </View>
  </View>
</View>


      <Footer />
       </Page>)}
      
    </Document>
  );
};

export default ReporteMtoDocuPDFV2;